import * as types from './actionTypes';
import {apiRequest, apiPost, apiDelete} from '../utils/request';
import {toastr} from 'react-redux-toastr';

export function loadTrucksSuccess(trucks){
  return {type: types.LOAD_TRUCKS_SUCCESS, trucks};
}

export function saveTruckSuccess(truck){
  return {type: types.SAVE_TRUCK_SUCCESS, truck};
}

export function deleteTruckSuccess(truck){
  return {type: types.DELETE_TRUCK_SUCCESS, truck};
}

export function loadCollectionTypesSuccess(collectionTypes){
  return {type: types.LOAD_COLLECTION_TYPES_SUCCESS, collectionTypes};
}

export function loadTrucks(includeInactive = false) {
  return function (dispatch) {
    dispatch(loadTrucksSuccess({loaded: false, items: []}));
    return apiRequest(`/api/trucks?includeInactive=${includeInactive}`)
      .then(x => {
        if (x.error || x.data.Message) {
          toastr.error(`Error while fetching trucks, error: ${x.error ? x.error : x.data.Message}`);
          dispatch(loadTrucksSuccess({loaded: true, items: []}));
        } else {
          dispatch(loadTrucksSuccess({loaded: true, items: Array.from(x.data)}));
        }
      });
  };
}

export function saveTruck(truck) {
  return function (dispatch) {
    toastr.success('Saving truck');
    return apiPost(`/api/trucks/${truck.id ? truck.id : -1}`, truck)
      .then(x => {
        if (x.error || x.data.Message) {
          toastr.error(`Error while fetching trucks, error: ${x.error ? x.error : x.data.Message}`);
        } else {
          dispatch(saveTruckSuccess(x.data));
        }
      });
  };
}


export function deleteTruck(truck) {
  return function (dispatch) {
    toastr.success('Deleting truck');
    return apiDelete(`/api/trucks/${truck.id}`)
      .then(x => {
        if (x.error || x.data.Message) {
          toastr.error(`Error while fetching trucks, error: ${x.error ? x.error : x.data.Message}`);
        } else {
          dispatch(deleteTruckSuccess(truck));
        }
      });
  };
}

export function loadCollectionTypes() {
  return function (dispatch) {
    return apiRequest(`/api/trucks/lookups/collection-types`)
      .then(x => {
        if (x.error || x.data.Message) {
          toastr.error(`Error while fetching collection types, error: ${x.error ? x.error : x.data.Message}`);
          dispatch(loadCollectionTypesSuccess([]));
        } else {
          dispatch(loadCollectionTypesSuccess(Array.from(x.data)));
        }
      });
  };
}